import React from "react";
import { Model } from "survey-core";
import { Survey } from "survey-react-ui";
import "survey-core/defaultV2.min.css"; 
import { json } from "./json";
import { themeJson } from "./theme";
import axios from 'axios'; 
// import nodemailer from 'nodemailer';

const SurveyComponent = () => {
  const handleSubmit = async (surveyData) => {
    try {
      // Send data to backend server
       // Define the API endpoint
    const apiEndpoint = `api/submit-survey`;
    const apiUrl = process.env.REACT_APP_API_BASE_URL + apiEndpoint;

      const response = await axios.post(apiUrl, surveyData);
      console.log("Response:", response.data);
    } catch (error) {
      console.error('Error submitting form:', error);
      alert("Error submitting form. Please try again later.");
    }
  };

  const survey = new Model(json);
  survey.applyTheme(themeJson);
  survey.onComplete.add(async (sender, options) => {
    await handleSubmit(sender.data);
  });

  return <Survey model={survey}/>;
}

export default SurveyComponent;
